export default class ActionItemRegistry {
    static registry = {
    }

    static register(data) {
        if (!data.itemType) throw "Action item type is missing";

        if (!_.isArray(data.itemType)) data.itemType = [data.itemType];

        data.itemType.forEach(t => {
            var regData = _.clone(data);
            delete regData.itemType;
            ActionItemRegistry.registry[t] = regData;
        });
    }

    static get(itemType) {
        return ActionItemRegistry.registry[itemType] || {
          itemType
        };
    }
}



// WEBPACK FOOTER //
// ./src/action-items/types/registry.js